module.exports = __webpack_public_path__ + "static/img/ttt-th.11c3f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/ttt-th.png
// module id = dYsH
// module chunks = 1